import { useState, useEffect } from 'react';
import { isMobile, isIOS } from '@/utils/isMobile';

export const useIsMobile = (): boolean => {
  const [isMobileState, setIsMobileState] = useState<boolean>(() => {
    return isMobile();
  });

  useEffect(() => {
    const updateIsMobile = () => {
      setIsMobileState(isMobile());
    };

    window.addEventListener('resize', updateIsMobile);
    window.addEventListener('orientationchange', updateIsMobile);

    return () => {
      window.removeEventListener('resize', updateIsMobile);
      window.removeEventListener('orientationchange', updateIsMobile);
    };
  }, []);

  return isMobileState;
};

export const useIsIOS = (): boolean => {
  const [isIOSState, setIsIOSState] = useState<boolean>(() => {
    return isIOS();
  });

  useEffect(() => {
    const updateIsIOS = () => {
      setIsIOSState(isIOS());
    };

    window.addEventListener('orientationchange', updateIsIOS);

    return () => {
      window.removeEventListener('orientationchange', updateIsIOS);
    };
  }, []);

  return isIOSState;
};
